import { render, staticRenderFns } from "./WithdrawTransactionVNPay.vue?vue&type=template&id=23ce0161&"
import script from "./WithdrawTransactionVNPay.vue?vue&type=script&lang=js&"
export * from "./WithdrawTransactionVNPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports